<template>
  <div class="about1">
    <div class="about1-img1">
      <img src="~@/assets/images/about-page1-img-1.jpg" />
      <div>
        <div>民國80年</div>
        <div>動土時間</div>
        <div>民國86年</div>
        <div>完工時間</div>
        <div>民國87年</div>
        <div>入廟時間</div>
        <div>民國89年</div>
        <div>建醮時間</div>
      </div>
    </div>
    <div>&nbsp;</div>
    <div>&nbsp;</div>
    <div>
      龍崎區中坑村內的關聖帝君文衡殿，巍峨聳立，氣度非凡，裡頭恭奉的是文衡聖帝，與其他傳統廟宇不同的是，它沒有冗長的歷史，卻有一段傳奇的故事。
    </div>
    <div>&nbsp;</div>
    <div>
      後甲關帝殿的信徒陳慶飛先生，25歲時怪病纏身，雙腳不良於行，每日仰賴藥物減輕疼痛，當時他每天不間斷的到台南後甲關帝殿虔誠祝禱，風雨無阻。民國56年10月6日午夜2點，在殿內跪拜祈禮時，突然五彩映照，霞光萬丈，身長七尺左右關帝爺現身顯靈，十五天後，他的怪病不藥而癒，隨後又受到聖示，投身建築事業，之後經營建築事業一帆風順，為了傳揚神蹟，造福其他信眾，新建文衡殿以感念神恩。
    </div>
    <div>&nbsp;</div>
    <div>
      創建於民國87年，主祀 文衡聖帝，原為簡易廟堂，由
      <a href="http://www.huanglong.com.tw/newcase.php" target="_blank"
        >皇龍建設公司</a
      >董事長 陳慶飛先生興建，該殿是由台南東區關帝廳及
      <a href="http://www.shianming-temple.tw/" target="_blank">前甲顯明殿</a
      >分靈至此，迄自陳慶飛先生卸任關帝殿主委乙職，深感關聖帝君神威佑庇
      顯赫無邊，然老廟年代久遠，腹地狹小，擴建不易，遂萌擇地於台南市龍崎區中坑現址，購地５０公頃有餘，闢建新殿宇，并廣植林木，建休閒設施，提供帝君信眾、遊客、鄰近縣市住居民眾茹沐神恩及休憩去處，從初創期之篳路籃蔞，宥於資金龐大，無法一舉就的，幸蒙帝君浩翰神恩，至今規模初具有成，得以成為南瀛之宗教中心之一。
    </div>
    <div>&nbsp;</div>
    <div>
      奉玉皇上帝旨意興建，廟身是以二進式建築屋深，分為前殿與後殿，莊嚴靜穆、巍峨聳立、氣度非凡。
    </div>
    <div>&nbsp;</div>
    <div>
      前殿供奉本廟主神 祖上帝君文衡聖帝；後殿特地奉請
      南海普陀山觀音佛祖駐駕，大慈大悲、浩瀚佛光，為眾善信消災祈福，廣佑國泰民安，庇護四時無災。
    </div>
    <div>&nbsp;</div>
    <div>
      鳳娘聖母、紫雲聖母隻神衹於建廟之時，即奉玉旨於菩薩座中修行，待功德圓滿後，與觀音佛祖共同鎮守【龍崎文衡殿】同享香火。
    </div>
    <div>&nbsp;</div>
    <swiper
      class="swiper"
      :key="swiperOption.slidesPerView"
      :options="swiperOption"
    >
      <swiper-slide>
        <img
          class="about1-swiper-img cursor-pointer"
          src="~@/assets/images/home-banner-1.jpg"
          @click="openModal()"
        />
      </swiper-slide>
      <swiper-slide>
        <img
          class="about1-swiper-img cursor-pointer"
          src="~@/assets/images/home-banner-2.jpg"
          @click="openModal()"
        />
      </swiper-slide>
      <swiper-slide>
        <img
          class="about1-swiper-img cursor-pointer"
          src="~@/assets/images/home-banner-3.jpg"
          @click="openModal()"
        />
      </swiper-slide>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
    <transition
      enter-active-class="fade-enter-active"
      leave-active-class="fade-leave-active"
    >
      <modal v-if="modalOpen" class="about1-modal" @onClose="closeModal()">
        <div slot="body">
          <swiper class="swiper" :options="modalSwiperOption">
            <swiper-slide>
              <img
                class="about1-swiper-img"
                src="~@/assets/images/home-banner-1.jpg"
              />
            </swiper-slide>
            <swiper-slide>
              <img
                class="about1-swiper-img"
                src="~@/assets/images/home-banner-2.jpg"
              />
            </swiper-slide>
            <swiper-slide>
              <img
                class="about1-swiper-img"
                src="~@/assets/images/home-banner-3.jpg"
              />
            </swiper-slide>
            <div
              class="swiper-button-prev about1-modal-button"
              slot="button-prev"
            ></div>
            <div
              class="swiper-button-next about1-modal-button"
              slot="button-next"
            ></div>
          </swiper>
        </div>
      </modal>
    </transition>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import Modal from 'Components/modal.vue';
import 'swiper/css/swiper.css';
export default {
  name: 'About1',
  components: {
    Swiper,
    SwiperSlide,
    Modal,
  },
  data() {
    return {
      page: this.$route.query.page,
      slidesPerView: 2,
      modalSwiperOption: {
        slidesPerView: 1,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      modalOpen: false,
    };
  },
  mounted() {
    const vm = this;
    vm.slidesPerView = window.innerWidth < 768 ? 1 : 2;
    window.onresize = () => {
      vm.slidesPerView = window.innerWidth < 768 ? 1 : 2;
    };
  },
  computed: {
    swiperOption: function() {
      return {
        slidesPerView: this.slidesPerView,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      };
    },
  },
  methods: {
    openModal() {
      this.modalOpen = true;
    },
    closeModal() {
      this.modalOpen = false;
    },
  },
  watch: {
    $route() {
      this.page = this.$route.query.page;
    },
  },
};
</script>

<style scoped>
.about1 img {
  width: 100%;
}

.about1-swiper-img {
  width: 100%;
}

.swiper-button-prev,
.swiper-button-next {
  color: #ffffff;
}

.fade-enter-active {
  animation: show 0.5s;
}

.fade-leave-active {
  animation: hide 0.5s;
}

.about1-img1 > div > div {
  width: 100%;
  text-align: center;
  font-size: 20px;
  padding: 10px;
}

.about1-img1 > div > div:nth-child(odd) {
  border-left: 1px solid #000;
  border-right: 1px solid #000;
  margin: 5px 0 3px 0;
}

.about1-img1 > div > div:nth-child(2),
.about1-img1 > div > div:nth-child(6) {
  background-color: #3a3a3a;
  color: #fff;
}

.about1-img1 > div > div:nth-child(4),
.about1-img1 > div > div:nth-child(8) {
  background-color: #5a5a5a;
  color: #fff;
}

@keyframes show {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes hide {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
@media (max-width: 767px) {
  .about1-modal-button {
    display: none;
  }
  .about1-img1 > img {
    display: none;
  }
}
@media (min-width: 768px) {
  .about1-img1 > div {
    display: none;
  }

  .about1-modal >>> .custom-modal-container {
    width: 90vw;
    min-width: 590px;
    max-width: inherit;
  }
}
</style>
